import { CustomerData, CustomerDocumentsStatus } from '@/components/hooks/useCustomerData';

export const isEndUserCertificateEnforced = (customerData: CustomerData | null): boolean => {
    if (!customerData) return false;

    return !customerData.isEndUserUltimateDestinationAccepted;
};

export const hasCustomerEnforcements = (customerData: CustomerData | null): boolean => {
    if (!customerData) return false;

    return (
        customerData.isClientArchived ||
        customerData.customerDocumentsStatus === CustomerDocumentsStatus.UploadEnforced ||
        customerData.customerDocumentsStatus === CustomerDocumentsStatus.UnderReview ||
        !customerData.areShippingRatesAccepted ||
        !customerData.areTermsAndConditionsAccepted ||
        !customerData.areNraTermsAndConditionsAccepted ||
        (customerData.isProtectionPlanShown && !customerData.isProtectionPlanAccepted) ||
        (customerData.isBillOfSaleShown && !customerData.isBillOfSaleAccepted) ||
        isEndUserCertificateEnforced(customerData)
    );
};

export const isCustomerArchived = (customerData: CustomerData | null): boolean => {
    return customerData?.isClientArchived ?? false;
};

export const getActiveEnforcements = (customerData: CustomerData | null): string[] => {
    if (!customerData) return [];

    const enforcements: string[] = [];

    if (customerData.customerDocumentsStatus === CustomerDocumentsStatus.UploadEnforced) {
        enforcements.push('documentsVerification');
    }
    if (customerData.customerDocumentsStatus === CustomerDocumentsStatus.UnderReview) {
        enforcements.push('documentsVerificationUnderReview');
    }
    if (!customerData.areShippingRatesAccepted) {
        enforcements.push('shippingRates');
    }
    if (!customerData.areTermsAndConditionsAccepted) {
        enforcements.push('termsConditions');
    }
    if (!customerData.areNraTermsAndConditionsAccepted) {
        enforcements.push('nraTermsConditions');
    }
    if (customerData.isProtectionPlanShown && !customerData.isProtectionPlanAccepted) {
        enforcements.push('protectionPlan');
    }
    if (customerData.isBillOfSaleShown && !customerData.isBillOfSaleAccepted) {
        enforcements.push('billOfSale');
    }
    if (isEndUserCertificateEnforced(customerData)) {
        enforcements.push('endUserUltimateDestinationCertificate');
    }

    return enforcements;
};
